import { RouteConfig } from 'vue-router';
import SandboxPromotions from './sandbox-promotions.vue';
import SandboxPromotionsHistory from './sandbox-promotions-history.vue';
import SandboxApplicablePromotions from './sandbox-applicable-promotions.vue';
import TransferServiceForSecureUpgrade from './transferServiceForSecureUpgrade.vue';
import CompetitiveTradeIn from './competitiveTradeIn.vue';
import ApplySecureUpgrade from './applySecureUpgrade.vue';

export const sandboxPromotions: RouteConfig = {
  path: 'promotions',
  component: SandboxPromotions,
};

export const sandboxPromotionsHistory: RouteConfig = {
  path: 'promotionHistory',
  component: SandboxPromotionsHistory,
};

export const sandboxApplicablePromotions: RouteConfig = {
  path: 'applicablePromotions',
  component: SandboxApplicablePromotions,
};

export const competitiveTradeIn: RouteConfig = {
  path: 'competitiveTradeIn',
  component: CompetitiveTradeIn,
};

export const applySecureUpgrade: RouteConfig = {
  path:'applySecureUpgrade',
  component: ApplySecureUpgrade,
};

export const mswTransferServiceForSecureUpgrade: RouteConfig = {
  path: 'transfersecureupgrade',
  component: TransferServiceForSecureUpgrade,
};
